// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import cngMeetingAgendaItemEntity from './entities/cng-meeting-agenda-item.json';
import cngMeetingAgendaItemMenu from '../pages/cng-meeting-agenda-item/menu.json';
import cngMeetingAgendaItemFullForm from '../pages/cng-meeting-agenda-item/forms/full.json';
import cngMeetingAgendaItemContextForm from '../pages/cng-meeting-agenda-item/forms/context.json';
import cngMeetingAgendaItemMiniForm from '../pages/cng-meeting-agenda-item/forms/mini.json';
import cngMeetingAgendaItemLookupForm from '../pages/cng-meeting-agenda-item/forms/lookup.json';
import cngMeetingAgendaItemTableView from '../pages/cng-meeting-agenda-item/views/table.json';
import cngMeetingAgendaItemCardsView from '../pages/cng-meeting-agenda-item/views/cards.json';
import cngMeetingAgendaItemDashboardView from '../pages/cng-meeting-agenda-item/views/dashboard.json';

/** Тип запису «Питання порядку денного» зі сторінками пакета: меню, форми та подання з pages/cng-meeting-agenda-item/. */
export const cngMeetingAgendaItemDefinition: IRecordTypeDefinition = {
  ...cngMeetingAgendaItemEntity,
  views: assembleViewSet({
      table: cngMeetingAgendaItemTableView,
      cards: cngMeetingAgendaItemCardsView,
      dashboard: cngMeetingAgendaItemDashboardView,
  }),
  form: cngMeetingAgendaItemFullForm,
  forms: { full: cngMeetingAgendaItemFullForm, context: cngMeetingAgendaItemContextForm, mini: cngMeetingAgendaItemMiniForm, lookup: cngMeetingAgendaItemLookupForm },
  menu: cngMeetingAgendaItemMenu,
} as IRecordTypeDefinition;
